import script from "./translate_text.vue?vue&type=script&setup=true&lang=js"
export * from "./translate_text.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__